
const defaultNavigationData = {
    cancel: {
        content: 'div',
        formType: 'cancel',
        name: 'cancel',
        title: 'TEXT__CANCEL'
    },
    change: {
        content: 'div',
        formType: 'change',
        name: 'change',
        title: 'TEXT__CHANGE'
    }
};

module.exports = defaultNavigationData;
